module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stream-browserify/~/readable-stream/writable-browser.js
// module id = 424
// module chunks = 2